import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import MailSidebar from '../components/MailSidebar';
import MailToolbar from '../components/MailToolbar';
import MailTable from '../components/MailTable';
import ThreadDrawer from '../components/ThreadDrawer';
import ComposeDialog from '../components/ComposeDialog';
import AddMailboxDialog from '../components/AddMailboxDialog';
import { useMessages } from '../hooks/useMessages';
import { useMailboxes } from '../hooks/useMailboxes';
import { useUnifiedInbox } from '../hooks/useUnifiedInbox';

export default function MailPage() {
  const [mailboxId, setMailboxId] = useState(null);
  const [folder, setFolder] = useState('INBOX');
  const [q, setQ] = useState('');
  const [unified, setUnified] = useState(false);
  const [selected, setSelected] = useState(null);
  const [composeOpen, setComposeOpen] = useState(false);
  const [addMailboxOpen, setAddMailboxOpen] = useState(false);

  const { data: mailboxes } = useMailboxes();
  const msgsQuery = useMessages(mailboxId, folder, { q });
  const unifiedQuery = useUnifiedInbox({ q });

  const rows = useMemo(() => {
    const src = unified ? (unifiedQuery.data || []).messages || [] : (msgsQuery.data || []).messages || [];
    return src.map(m => ({
      ...m,
      mailboxId: m.mailboxId || mailboxId,
      folder: m.folder || folder,
      mailboxDisplay: (m.mailboxId || mailboxId) && mailboxes?.find(x=>String(x.id)===String(m.mailboxId || mailboxId))?.displayName
    })) || [];
  }, [msgsQuery.data, unifiedQuery.data, unified, mailboxes, mailboxId, folder]);

  return (
    <Box sx={{ display: 'flex', gap: 2, bgcolor: '#F7F8FA', height: '100vh', p: 2 }}>
      <MailSidebar 
        mailboxId={mailboxId} 
        setMailboxId={setMailboxId} 
        folder={folder} 
        setFolder={setFolder}
        onAddMailbox={() => setAddMailboxOpen(true)}
      />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <MailToolbar q={q} setQ={setQ} unified={unified} setUnified={setUnified} onRefresh={() => { /* refetch handled by hooks automatically */ }} onCompose={() => setComposeOpen(true)} />
        <Box sx={{ flex: 1, p: 2 }}>
          <MailTable rows={rows} unified={unified} onRowClick={(r) => setSelected(r)} />
        </Box>
      </Box>
      <ThreadDrawer open={!!selected} onClose={() => setSelected(null)} messageId={selected?.messageId || selected?.messageId} onActionComplete={() => { /* no-op */ }} />
      <ComposeDialog open={composeOpen} onClose={() => setComposeOpen(false)} mailboxes={mailboxes || []} />
      <AddMailboxDialog open={addMailboxOpen} onClose={() => setAddMailboxOpen(false)} />
    </Box>
  );
}
